(function () {
  if (window.CustomCartUpsellsInit) return;
  window.CustomCartUpsellsInit = true;

  var SWIPER_CSS_URL = "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.css";
  var SWIPER_JS_URL = "https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js";
  var swiperLoadingPromise = null;
  var upsellDropupCounter = 0;

  function ensureSwiperLoaded() {
    if (window.Swiper) return Promise.resolve();
    if (swiperLoadingPromise) return swiperLoadingPromise;

    swiperLoadingPromise = new Promise(function (resolve, reject) {
      if (!document.querySelector("link[data-upsells-swiper-css]")) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = SWIPER_CSS_URL;
        link.setAttribute("data-upsells-swiper-css", "1");
        document.head.appendChild(link);
      }

      if (document.querySelector("script[data-upsells-swiper-js]")) {
        var t = 0;
        var iv = setInterval(function () {
          t += 50;
          if (window.Swiper) {
            clearInterval(iv);
            resolve();
          }
          if (t > 8000) {
            clearInterval(iv);
            reject(new Error("Swiper load timeout"));
          }
        }, 50);
        return;
      }

      var s = document.createElement("script");
      s.src = SWIPER_JS_URL;
      s.async = true;
      s.setAttribute("data-upsells-swiper-js", "1");
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error("Failed to load Swiper")); };
      document.head.appendChild(s);
    });

    return swiperLoadingPromise;
  }

  function getDrawerEl() {
    return (
      document.querySelector("[data-cart-drawer]") ||
      document.querySelector("#cart-drawer") ||
      document.querySelector(".quick-cart__wrapper") ||
      document.querySelector(".quick-cart") ||
      document.querySelector(".mini-cart__inner") ||
      null
    );
  }

  function getUpsellsRoot() {
    var drawer = getDrawerEl();
    if (drawer) {
      var r = drawer.querySelector("[data-cart-upsells-root]");
      if (r) return r;
    }
    return document.querySelector("[data-cart-upsells-root]");
  }

  function getQuickCartItemsEl() {
    var drawer = getDrawerEl();

    if (!drawer) {
      return (
        document.querySelector("[data-cart-form]") ||
        document.querySelector("[data-cart-wrapper]") ||
        document.querySelector(".quick-cart__items")
      );
    }

    return (
      drawer.querySelector("[data-cart-form]") ||
      drawer.querySelector("[data-cart-wrapper]") ||
      drawer.querySelector(".quick-cart__items") ||
      document.querySelector("[data-cart-form]") ||
      document.querySelector("[data-cart-wrapper]") ||
      document.querySelector(".quick-cart__items")
    );
  }

  function getCartDrawerBody() {
    var drawer = getDrawerEl();

    return (
      (drawer && drawer.querySelector("[data-cart-drawer-body]")) ||
      document.querySelector("[data-cart-drawer-body]")
    );
  }

  function getCartWrapper() {
    var drawer = getDrawerEl();

    return (
      (drawer && drawer.querySelector("[data-cart-wrapper]")) ||
      document.querySelector("[data-cart-wrapper]")
    );
  }

  function getCartSectionId() {
    var wrapper = getCartWrapper();
    return (wrapper && wrapper.getAttribute("data-section")) || "ajax-cart";
  }

  function safeCall(fnName, arg) {
    if (typeof window[fnName] === "function") {
      try {
        return window[fnName](arg);
      } catch (e) {}
    }
  }

  function reinitCartDrawer(cartBody, itemCount) {
    if (!cartBody) return;

    if (typeof window.cartCountUpdate === "function") {
      try { window.cartCountUpdate(itemCount || 0); } catch (e) {}
    } else {
      document.querySelectorAll("[data-header-cart-count]").forEach(function (el) {
        el.textContent = itemCount > 0 ? String(itemCount) : "";
        el.classList.toggle("hidden", !(itemCount > 0));
      });
    }

    safeCall("getQuantityElement", cartBody);
    safeCall("getCartItemRemoveElements", cartBody);
    safeCall("cartNoteDrawerInt", getDrawerEl() || cartBody);
    safeCall("cartNoteUpdate", cartBody);

    setupQuickCartItemsObserver();

    lastSignature = null;
    scheduleRender(true);
  }

  function updateCartDrawerFromSectionHtml(sectionHtml) {
    if (!sectionHtml) return false;

    var parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    var updatedSection = parsed.querySelector(".shopify-section") || parsed;
    var updatedWrapper = updatedSection.querySelector("[data-cart-wrapper]");
    var cartBody = getCartDrawerBody();

    if (!updatedWrapper || !cartBody) return false;

    closeUpsellVariantDropups();

    cartBody.innerHTML = updatedSection.innerHTML;

    var freshWrapper = cartBody.querySelector("[data-cart-wrapper]");
    var itemCount = parseInt((freshWrapper && freshWrapper.getAttribute("data-item-count")) || "0", 10);

    reinitCartDrawer(cartBody, itemCount);

    var drawer = getDrawerEl();
    if (drawer) {
      drawer.classList.add("sd-sidebar--visible");
      document.body.classList.add("no-scroll");
    }

    return true;
  }

  function fetchRenderedCartSection(sectionId) {
    var url = getShopRoot() + "?sections=" + encodeURIComponent(sectionId);

    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (sections) {
        if (sections && sections[sectionId]) {
          updateCartDrawerFromSectionHtml(sections[sectionId]);
        }
      })
      .catch(function () {});
  }

  function addUpsellToCart(variantId) {
    var sectionId = getCartSectionId();
    var url = getShopRoot() + "cart/add.js";

    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: [sectionId],
        sections_url: window.location.pathname
      }),
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response && response.status) throw response;

        if (response && response.sections && response.sections[sectionId]) {
          if (updateCartDrawerFromSectionHtml(response.sections[sectionId])) return;
        }

        return fetchRenderedCartSection(sectionId);
      });
  }

  function isElementVisible(el) {
    if (!el) return false;

    if (el.classList && el.classList.contains("quick-cart__wrapper") && !el.classList.contains("active")) {
      return false;
    }

    var ah = el.getAttribute && el.getAttribute("aria-hidden");
    if (ah === "true") return false;

    var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (cs) {
      if (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) === 0) return false;
    }

    var r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    if (!r) return true;

    return r.width > 0 && r.height > 0;
  }

  function destroyUpsellsSwiper(root) {
    if (!root) return;

    if (root._upsellsSwiper && typeof root._upsellsSwiper.destroy === "function") {
      try { root._upsellsSwiper.destroy(true, true); } catch (e) {}
    }

    root._upsellsSwiper = null;
  }

  function initUpsellsSwiper(root) {
    if (!root || !window.Swiper) return;

    var swiperEl = root.querySelector("[data-upsells-swiper]");
    var wrapper = root.querySelector("[data-cart-upsells-list]");

    if (!swiperEl || !wrapper) return;

    var slidesCount = wrapper.querySelectorAll(".swiper-slide").length;

    if (!slidesCount) {
      destroyUpsellsSwiper(root);
      return;
    }

    destroyUpsellsSwiper(root);

    var prevEl = root.querySelector("[data-upsells-prev]");
    var nextEl = root.querySelector("[data-upsells-next]");

    root._upsellsSwiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      watchOverflow: true,
      centeredSlides: false,

      navigation: {
        prevEl: prevEl,
        nextEl: nextEl
      },

      allowTouchMove: true,
      simulateTouch: true,
      touchEventsTarget: "container",
      touchRatio: 1.35,
      threshold: 3,
      touchAngle: 65,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.12,
      longSwipesMs: 220,
      followFinger: true,
      resistance: true,
      resistanceRatio: 0.65,
      nested: true,
      passiveListeners: false,

      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,

      noSwiping: true,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: "select, option, input, textarea, button, [data-upsell-variant-select], [data-upsell-custom-select], .cart-upsells__variant-row",

      observer: true,
      observeParents: true,
      observeSlideChildren: false
    });
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === "number" ? precision : 2;
    thousands = typeof thousands === "string" ? thousands : ",";
    decimal = typeof decimal === "string" ? decimal : ".";

    if (isNaN(number) || number === null) return "0";

    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split(".");
    var dollars = parts[0];
    var cents = parts[1] ? decimal + parts[1] : "";
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(dollars)) {
      dollars = dollars.replace(rgx, "$1" + thousands + "$2");
    }

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }

    if (typeof cents === "string") cents = cents.replace(".", "");

    var formatString = format || (window.Shopify && window.Shopify.money_format) || "${{amount}}";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : "amount";
    var value = "";

    switch (placeholder) {
      case "amount": value = formatWithDelimiters(cents, 2, ",", "."); break;
      case "amount_no_decimals": value = formatWithDelimiters(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": value = formatWithDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = formatWithDelimiters(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
      case "amount_no_decimals_with_space_separator": value = formatWithDelimiters(cents, 0, " ", "."); break;
      case "amount_with_period_and_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
      case "amount_with_apostrophe_separator": value = formatWithDelimiters(cents, 2, "'", "."); break;
      default: value = formatWithDelimiters(cents, 2, ",", "."); break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; });
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return "";

    var ids = cart.items.map(function (i) {
      return i.product_id + "x" + i.quantity;
    }).join("|");

    return cart.item_count + "::" + ids;
  }

  function getShopRoot() {
    var root = "/";

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }

    return root.replace(/\/?$/, "/");
  }

  function getRecommendationsUrl(productId, intent, limit) {
    var base = getShopRoot();

    return (
      base +
      "recommendations/products.json?product_id=" + encodeURIComponent(productId) +
      "&intent=" + encodeURIComponent(intent) +
      "&limit=" + encodeURIComponent(limit * 3)
    );
  }

  function fetchRecommendationsForProduct(productId, intent, limit) {
    var url = getRecommendationsUrl(productId, intent, limit);

    return fetch(url, { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }

  function getCustomProductsFromRoot(root) {
    if (!root) return [];

    var script = root.querySelector("[data-upsells-custom-products]");
    if (!script) return [];

    var raw = script.textContent || "[]";

    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function updateUpsellPriceFromSelect(selectEl) {
    if (!selectEl) return;

    var card = selectEl.closest(".cart-upsells__item");
    if (!card) return;

    var priceWrap = card.querySelector(".cart-upsells__price");
    if (!priceWrap) return;

    var root = card.closest("[data-cart-upsells-root]");
    var moneyFormat =
      (root && root.getAttribute("data-upsells-money-format")) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    var price = parseInt(opt.getAttribute("data-price") || "0", 10);
    var compareAt = parseInt(opt.getAttribute("data-compare-at") || "0", 10);

    var html = "";

    if (compareAt && compareAt > price) {
      html =
        '<span class="cart-upsells__price-old">' + formatMoney(compareAt, moneyFormat) + "</span>" +
        '<span class="cart-upsells__price-new">' + formatMoney(price, moneyFormat) + "</span>";
    } else {
      html = '<span class="cart-upsells__price-regular">' + formatMoney(price, moneyFormat) + "</span>";
    }

    priceWrap.innerHTML = html;
  }

  function buildCardsHtml(products, inCartProductIds, moneyFormat, limit) {
    var usedIds = new Set();
    var picked = [];

    products.forEach(function (p) {
      if (!p || p.available === false) return;
      if (inCartProductIds.indexOf(p.id) !== -1) return;
      if (usedIds.has(p.id)) return;
      if (picked.length >= limit) return;

      usedIds.add(p.id);
      picked.push(p);
    });

    if (!picked.length) return "";

    return picked.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]);
      var imgUrl = null;

      if (img && typeof img === "string") {
        imgUrl = img.replace(/_(\d+x\d+|x\d+)\./, "_160x.");
      } else if (img && img.src) {
        imgUrl = img.src;
      }

      var title = p.title || "";
      var words = title.split(" ").filter(function (w) { return w.length; });
      var shortTitle = words.slice(0, 5).join(" ");
      if (words.length > 5) shortTitle += "…";

      var variants = p.variants || [];
      var fav = null;

      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) {
          fav = variants[i];
          break;
        }
      }

      if (!fav && variants.length) fav = variants[0] || null;

      var selectedVariant = fav || null;
      var basePrice = selectedVariant && selectedVariant.price != null ? selectedVariant.price : p.price;
      var baseCompareAt = selectedVariant && selectedVariant.compare_at_price != null
        ? selectedVariant.compare_at_price
        : p.compare_at_price;

      var priceHtml = "";

      if (baseCompareAt && baseCompareAt > basePrice) {
        priceHtml =
          '<span class="cart-upsells__price-old">' + formatMoney(baseCompareAt, moneyFormat) + "</span>" +
          '<span class="cart-upsells__price-new">' + formatMoney(basePrice, moneyFormat) + "</span>";
      } else {
        priceHtml = '<span class="cart-upsells__price-regular">' + formatMoney(basePrice, moneyFormat) + "</span>";
      }

      var hasMultipleVariants = variants.length > 1;
      var selectedVariantId = selectedVariant && selectedVariant.id;
      var handle = p.handle || "";
      var productUrl = p.url || (handle ? getShopRoot() + "products/" + handle : "#");
      var selectorHtml = "";

      if (hasMultipleVariants) {
        var selectedLabel = selectedVariant ? (selectedVariant.public_title || selectedVariant.title || "") : "";

        selectorHtml += '<div class="cart-upsells__variant-row swiper-no-swiping" data-upsell-custom-select>';
        selectorHtml += '<select class="cart-upsells__variant-select cart-upsells__variant-select--native" data-upsell-variant-select tabindex="-1" aria-hidden="true">';

        variants.forEach(function (v) {
          if (!v) return;

          var optLabel = v.public_title || v.title || "";

          selectorHtml +=
            '<option value="' + v.id + '"' +
              (selectedVariantId && String(v.id) === String(selectedVariantId) ? " selected" : "") +
              ' data-price="' + (v.price || 0) + '"' +
              ' data-compare-at="' + (v.compare_at_price || 0) + '">' +
              optLabel +
            "</option>";
        });

        selectorHtml += "</select>";

        selectorHtml +=
          '<button type="button" class="cart-upsells__variant-trigger" data-upsell-variant-trigger aria-expanded="false">' +
            '<span data-upsell-variant-trigger-text>' + selectedLabel + "</span>" +
            '<span class="cart-upsells__variant-trigger-icon" aria-hidden="true">' +
              '<svg width="9" height="6" viewBox="0 0 9 6" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M1 1l3.5 4L8 1" stroke="currentColor" stroke-width="1.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
              "</svg>" +
            "</span>" +
          "</button>";

        selectorHtml += '<div class="cart-upsells__variant-dropdown" data-upsell-variant-dropdown role="listbox">';

        variants.forEach(function (v) {
          if (!v) return;

          var optionLabel = v.public_title || v.title || "";
          var isSelected = selectedVariantId && String(v.id) === String(selectedVariantId);

          selectorHtml +=
            '<button type="button" class="cart-upsells__variant-option' + (isSelected ? " is-active" : "") + '"' +
              ' data-upsell-variant-option' +
              ' data-variant-id="' + v.id + '"' +
              ' role="option"' +
              ' aria-selected="' + (isSelected ? "true" : "false") + '">' +
              optionLabel +
            "</button>";
        });

        selectorHtml += "</div>";
        selectorHtml += "</div>";
      }

      var buttonHtml = "";

      if (!hasMultipleVariants && selectedVariant && selectedVariant.id) {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add data-variant-id="' + selectedVariant.id + '">' +
            '<span class="cart-upsells__add-icon">+</span>' +
          "</button>";
      } else {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add>' +
            '<span class="cart-upsells__add-icon">+</span>' +
          "</button>";
      }

      var cardHtml =
        '<div class="cart-upsells__item">' +
          '<div class="cart-upsells__row">' +
            '<a href="' + productUrl + '" class="cart-upsells__media" data-instant>' +
              (imgUrl ? '<img src="' + imgUrl + '" alt="' + shortTitle.replace(/"/g, "&quot;") + '">' : "") +
            "</a>" +
            '<div class="cart-upsells__content">' +
              '<a href="' + productUrl + '" class="cart-upsells__title" data-instant>' + shortTitle + "</a>" +
              '<div class="cart-upsells__price">' + priceHtml + "</div>" +
              (selectorHtml || "") +
            "</div>" +
            buttonHtml +
          "</div>" +
        "</div>";

      return '<div class="swiper-slide">' + cardHtml + "</div>";
    }).join("");
  }

  var lastSignature = null;
  var updating = false;
  var pendingRender = false;
  var rafQueued = false;
  var suppressObservers = false;
  var suppressTimer = null;

  function suppressFor(ms) {
    suppressObservers = true;
    clearTimeout(suppressTimer);

    suppressTimer = setTimeout(function () {
      suppressObservers = false;
    }, ms || 180);
  }

  function scheduleRender(force) {
    if (rafQueued) return;

    rafQueued = true;

    requestAnimationFrame(function () {
      rafQueued = false;
      doRender(!!force);
    });
  }

  function doRender(force) {
    var drawer = getDrawerEl();
    var root = getUpsellsRoot();

    if (!root) return;

    if (!force) {
      if (!isElementVisible(drawer) && !isElementVisible(root)) return;
    }

    if (updating) {
      pendingRender = true;
      return;
    }

    renderCartUpsells(force);
  }

  function renderCartUpsells(force) {
    var root = getUpsellsRoot();

    if (!root) return;

    var listEl = root.querySelector("[data-cart-upsells-list]");

    if (!listEl) return;

    updating = true;

    var intent = root.getAttribute("data-upsells-intent") || "complementary";
    var limit = parseInt(root.getAttribute("data-upsells-limit") || "3", 10);
    var moneyFormat =
      root.getAttribute("data-upsells-money-format") ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    fetchCart().then(function (cart) {
      var sig = cartSignature(cart);

      if (sig === lastSignature && listEl.querySelector(".swiper-slide")) {
        updating = false;

        if (pendingRender) {
          pendingRender = false;
          scheduleRender(false);
        }

        return;
      }

      lastSignature = sig;

      if (!cart || !cart.items || !cart.items.length) {
        suppressFor(150);
        root.style.display = "none";
        closeUpsellVariantDropups();
        listEl.innerHTML = "";
        destroyUpsellsSwiper(root);

        updating = false;

        if (pendingRender) {
          pendingRender = false;
          scheduleRender(false);
        }

        return;
      }

      var inCartProductIds = cart.items.map(function (i) { return i.product_id; });

      function finish(products) {
        var html = buildCardsHtml(products || [], inCartProductIds, moneyFormat, limit);

        suppressFor(220);

        if (!html) {
          root.style.display = "none";
          closeUpsellVariantDropups();
          listEl.innerHTML = "";
          destroyUpsellsSwiper(root);

          updating = false;

          if (pendingRender) {
            pendingRender = false;
            scheduleRender(false);
          }

          return;
        }

        root.style.display = "";
        closeUpsellVariantDropups();
        listEl.innerHTML = html;

        var selects = listEl.querySelectorAll("[data-upsell-variant-select]");

        selects.forEach(function (sel) {
          updateUpsellPriceFromSelect(sel);
          syncUpsellCustomSelectFromNative(sel);
        });

        ensureSwiperLoaded()
          .then(function () {
            initUpsellsSwiper(root);

            setTimeout(function () {
              if (root._upsellsSwiper && typeof root._upsellsSwiper.update === "function") {
                root._upsellsSwiper.update();
              }
            }, 50);
          })
          .catch(function () {});

        updating = false;

        if (pendingRender) {
          pendingRender = false;
          scheduleRender(false);
        }
      }

      if (intent === "custom") {
        finish(getCustomProductsFromRoot(root));
        return;
      }

      var allRecs = [];
      var productIds = inCartProductIds.slice();
      var idx = 0;

      function step() {
        if (idx >= productIds.length || allRecs.length >= limit * 3) {
          finish(allRecs);
          return;
        }

        var pid = productIds[idx++];

        fetchRecommendationsForProduct(pid, intent, limit)
          .then(function (data) {
            if (data && Array.isArray(data.products)) {
              allRecs = allRecs.concat(data.products);
            }

            step();
          })
          .catch(function () {
            step();
          });
      }

      step();
    }).catch(function () {
      updating = false;

      if (pendingRender) {
        pendingRender = false;
        scheduleRender(false);
      }
    });
  }

  function setupQuickCartItemsObserver() {
    var itemsEl = getQuickCartItemsEl();

    if (!itemsEl) return;

    var existing = window.CustomCartUpsellsQCItemsObserver;

    if (existing && existing.el === itemsEl && existing.obs) return;

    if (existing && existing.obs) {
      try { existing.obs.disconnect(); } catch (e) {}
    }

    var obs = new MutationObserver(function (muts) {
      if (suppressObservers) return;

      var root = getUpsellsRoot();

      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (root && t && root.contains(t)) return;
      }

      if (itemsEl.querySelector && itemsEl.querySelector("[data-cart-upsells-root]")) {
        setTimeout(function () {
          lastSignature = null;
          scheduleRender(true);
        }, 0);
      }
    });

    obs.observe(itemsEl, { childList: true, subtree: true });

    window.CustomCartUpsellsQCItemsObserver = { obs: obs, el: itemsEl };
  }

  function setupInsertionObserver() {
    if (window.CustomCartUpsellsInsertionObserver) return;

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        var nodes = m.addedNodes || [];

        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];

          if (!n || n.nodeType !== 1) continue;

          if (
            (n.matches && (n.matches("[data-cart-wrapper]") || n.matches("[data-cart-form]") || n.matches("[data-cart-upsells-root]"))) ||
            (n.querySelector && (n.querySelector("[data-cart-wrapper]") || n.querySelector("[data-cart-form]") || n.querySelector("[data-cart-upsells-root]")))
          ) {
            setupQuickCartItemsObserver();
            scheduleRender(true);
            return;
          }
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    window.CustomCartUpsellsInsertionObserver = obs;
  }

  function setUpsellsSwiperTouch(root, enabled) {
    if (!root || !root._upsellsSwiper) return;

    root._upsellsSwiper.allowTouchMove = enabled;

    if (typeof root._upsellsSwiper.update === "function") {
      root._upsellsSwiper.update();
    }
  }

  function getUpsellsRootFromEventTarget(target) {
    var el = target && target.closest ? target.closest("[data-cart-upsells-root]") : null;
    return el || getUpsellsRoot();
  }

  function getUpsellDropupId(row) {
    if (!row) return "";

    if (!row.getAttribute("data-upsell-dropup-id")) {
      upsellDropupCounter += 1;
      row.setAttribute("data-upsell-dropup-id", "upsell-dropup-" + upsellDropupCounter);
    }

    return row.getAttribute("data-upsell-dropup-id");
  }

  function getRowByDropup(dropdown) {
    if (!dropdown) return null;

    var ownerId = dropdown.getAttribute("data-upsell-dropup-owner");
    if (!ownerId) return null;

    return document.querySelector('[data-upsell-custom-select][data-upsell-dropup-id="' + ownerId + '"]');
  }

  function getDropdownByRow(row) {
    if (!row) return null;

    var rowId = getUpsellDropupId(row);

    return (
      row.querySelector("[data-upsell-variant-dropdown]") ||
      document.querySelector('[data-upsell-variant-dropdown][data-upsell-dropup-owner="' + rowId + '"]')
    );
  }

  function positionUpsellVariantDropup(row) {
    if (!row) return;

    var trigger = row.querySelector("[data-upsell-variant-trigger]");
    var dropdown = getDropdownByRow(row);

    if (!trigger || !dropdown) return;

    var rowId = getUpsellDropupId(row);
    dropdown.setAttribute("data-upsell-dropup-owner", rowId);

    if (dropdown.parentElement !== document.body) {
      document.body.appendChild(dropdown);
    }

    var triggerRect = trigger.getBoundingClientRect();

    dropdown.classList.add("is-open", "is-positioning");

    dropdown.style.setProperty("--upsell-dropdown-width", triggerRect.width + "px");
    dropdown.style.setProperty("--upsell-dropdown-left", triggerRect.left + "px");
    dropdown.style.setProperty("--upsell-dropdown-top", "0px");

    var dropdownHeight = dropdown.offsetHeight || 160;
    var dropdownWidth = dropdown.offsetWidth || triggerRect.width;
    var left = triggerRect.left;
    var top = triggerRect.top - dropdownHeight - 4;

    if (left + dropdownWidth > window.innerWidth - 8) {
      left = window.innerWidth - dropdownWidth - 8;
    }

    if (left < 8) {
      left = 8;
    }

    if (top < 8) {
      top = triggerRect.bottom + 4;
    }

    dropdown.style.setProperty("--upsell-dropdown-left", left + "px");
    dropdown.style.setProperty("--upsell-dropdown-top", top + "px");
    dropdown.style.setProperty("--upsell-dropdown-width", triggerRect.width + "px");

    dropdown.classList.remove("is-positioning");
  }

  function openUpsellVariantDropup(row) {
    if (!row) return;

    var trigger = row.querySelector("[data-upsell-variant-trigger]");
    var dropdown = getDropdownByRow(row);

    if (!trigger || !dropdown) return;

    closeUpsellVariantDropups(row);

    row.classList.add("is-open");
    trigger.setAttribute("aria-expanded", "true");

    positionUpsellVariantDropup(row);
  }

  function closeUpsellVariantDropups(exceptRow) {
    document.querySelectorAll("[data-upsell-custom-select].is-open").forEach(function (row) {
      if (exceptRow && row === exceptRow) return;

      row.classList.remove("is-open");

      var trigger = row.querySelector("[data-upsell-variant-trigger]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });

    document.querySelectorAll("[data-upsell-variant-dropdown].is-open").forEach(function (dropdown) {
      var row = getRowByDropup(dropdown);

      if (exceptRow && row === exceptRow) return;

      dropdown.classList.remove("is-open", "is-positioning");

      if (row && dropdown.parentElement !== row) {
        row.appendChild(dropdown);
      }
    });
  }

  function syncUpsellCustomSelectFromNative(select) {
    if (!select) return;

    var row = select.closest("[data-upsell-custom-select]");
    if (!row) return;

    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    var triggerText = row.querySelector("[data-upsell-variant-trigger-text]");

    if (triggerText) {
      triggerText.textContent = selectedOption.textContent;
    }

    var dropdown = getDropdownByRow(row);

    if (!dropdown) return;

    dropdown.querySelectorAll("[data-upsell-variant-option]").forEach(function (button) {
      var isActive = String(button.getAttribute("data-variant-id")) === String(select.value);

      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-upsell-variant-trigger]");
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var row = trigger.closest("[data-upsell-custom-select]");
    if (!row) return;

    var root = getUpsellsRootFromEventTarget(row);
    setUpsellsSwiperTouch(root, false);

    if (row.classList.contains("is-open")) {
      closeUpsellVariantDropups();
    } else {
      openUpsellVariantDropup(row);
    }
  }, true);

  document.addEventListener("click", function (event) {
    var option = event.target.closest("[data-upsell-variant-option]");
    if (!option) return;

    event.preventDefault();
    event.stopPropagation();

    var dropdown = option.closest("[data-upsell-variant-dropdown]");
    var row = getRowByDropup(dropdown);

    if (!row) {
      row = option.closest("[data-upsell-custom-select]");
    }

    if (!row) return;

    var select = row.querySelector("[data-upsell-variant-select]");
    if (!select) return;

    select.value = option.getAttribute("data-variant-id");

    syncUpsellCustomSelectFromNative(select);
    select.dispatchEvent(new Event("change", { bubbles: true }));
    closeUpsellVariantDropups();

    var root = getUpsellsRootFromEventTarget(row);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 80);
  }, true);

  document.addEventListener("click", function (event) {
    if (
      event.target.closest("[data-upsell-custom-select]") ||
      event.target.closest("[data-upsell-variant-dropdown]")
    ) {
      return;
    }

    closeUpsellVariantDropups();
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeUpsellVariantDropups();

      var root = getUpsellsRoot();

      setTimeout(function () {
        setUpsellsSwiperTouch(root, true);
      }, 80);
    }
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-upsell-custom-select].is-open").forEach(positionUpsellVariantDropup);
  });

  document.addEventListener(
    "scroll",
    function () {
      document.querySelectorAll("[data-upsell-custom-select].is-open").forEach(positionUpsellVariantDropup);
    },
    true
  );

  ["pointerdown", "mousedown", "touchstart"].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var selectArea = event.target.closest("[data-upsell-variant-select], [data-upsell-custom-select], .cart-upsells__variant-row, [data-upsell-variant-dropdown]");
      if (!selectArea) return;

      event.stopPropagation();

      var root = getUpsellsRootFromEventTarget(selectArea);
      setUpsellsSwiperTouch(root, false);
    }, true);
  });

  ["pointerup", "mouseup", "touchend", "touchcancel"].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var root = getUpsellsRootFromEventTarget(event.target);

      setTimeout(function () {
        setUpsellsSwiperTouch(root, true);
      }, 80);
    }, true);
  });

  document.addEventListener("click", function (event) {
    var selectArea = event.target.closest("[data-upsell-variant-select], [data-upsell-custom-select], .cart-upsells__variant-row, [data-upsell-variant-dropdown]");
    if (!selectArea) return;

    event.stopPropagation();

    var root = getUpsellsRootFromEventTarget(selectArea);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 120);
  }, true);

  document.addEventListener("focusout", function (event) {
    var select = event.target.closest("[data-upsell-variant-select]");
    if (!select) return;

    var root = getUpsellsRootFromEventTarget(select);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 120);
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-upsell-variant-select]");
    if (!select) return;

    syncUpsellCustomSelectFromNative(select);
    updateUpsellPriceFromSelect(select);

    var root = getUpsellsRootFromEventTarget(select);

    setTimeout(function () {
      setUpsellsSwiperTouch(root, true);
    }, 80);
  });

  function afterCartChange() {
    setTimeout(function () {
      lastSignature = null;
      setupQuickCartItemsObserver();
      scheduleRender(true);
    }, 0);

    setTimeout(function () {
      lastSignature = null;
      scheduleRender(true);
    }, 250);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-cart-upsell-add]");
    if (!button) return;

    var variantId = button.getAttribute("data-variant-id");

    if (!variantId) {
      var card = button.closest(".cart-upsells__item");

      if (card) {
        var select = card.querySelector("[data-upsell-variant-select]");
        if (select) variantId = select.value;
      }
    }

    if (!variantId) return;

    event.preventDefault();
    event.stopPropagation();

    button.disabled = true;
    button.classList.add("is-loading");

    addUpsellToCart(variantId)
      .then(function () {
        button.disabled = false;
        button.classList.remove("is-loading");

        try {
          document.dispatchEvent(new CustomEvent("apps:product-added-to-cart"));
          document.dispatchEvent(new CustomEvent("cart:updated"));
        } catch (e) {}

        afterCartChange();
      })
      .catch(function (error) {
        button.disabled = false;
        button.classList.remove("is-loading");

        var card = button.closest(".cart-upsells__item");

        if (card) {
          card.setAttribute("data-upsell-error", (error && (error.description || error.message)) || "Could not add item");
        }
      });
  });

  setupInsertionObserver();
  setupQuickCartItemsObserver();
  scheduleRender(true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setupInsertionObserver();
      setupQuickCartItemsObserver();
      scheduleRender(true);
    });
  }
})();